// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-sidebar {
  width: 250px;
  background: #1e1e1e;
  color: white;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: transform 0.3s ease;
}

.admin-sidebar.closed {
  transform: translateX(-100%);
}

.sidebar-header {
  padding: 20px;
  border-bottom: 1px solid #333;
}

.sidebar-header h2 {
  margin: 0;
  font-size: 20px;
  color: white;
}

.sidebar-nav {
  flex: 1 1;
  padding: 10px 0;
  overflow-y: auto;
}

.nav-item {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 15px 20px;
  background: none;
  border: none;
  color: #ccc;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
  font-size: 15px;
}

.nav-item:hover {
  background: #2a2a2a;
  color: white;
}

.nav-item:focus {
  outline: 2px solid #1976d2;
  outline-offset: -2px;
}

.nav-item.active {
  background: #1976d2;
  color: white;
}

.nav-item.active:focus {
  outline: 2px solid #ffffff;
  outline-offset: -2px;
}

.nav-icon {
  margin-right: 12px;
  font-size: 20px;
}

.nav-label {
  flex: 1 1;
}

@media (max-width: 768px) {
  .admin-sidebar {
    width: 250px;
  }
  
  .nav-label {
    font-size: 14px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/admin/components/AdminSidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,OAAO;EACP,MAAM;EACN,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".admin-sidebar {\n  width: 250px;\n  background: #1e1e1e;\n  color: white;\n  height: 100vh;\n  position: fixed;\n  left: 0;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  transition: transform 0.3s ease;\n}\n\n.admin-sidebar.closed {\n  transform: translateX(-100%);\n}\n\n.sidebar-header {\n  padding: 20px;\n  border-bottom: 1px solid #333;\n}\n\n.sidebar-header h2 {\n  margin: 0;\n  font-size: 20px;\n  color: white;\n}\n\n.sidebar-nav {\n  flex: 1;\n  padding: 10px 0;\n  overflow-y: auto;\n}\n\n.nav-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding: 15px 20px;\n  background: none;\n  border: none;\n  color: #ccc;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: left;\n  font-size: 15px;\n}\n\n.nav-item:hover {\n  background: #2a2a2a;\n  color: white;\n}\n\n.nav-item:focus {\n  outline: 2px solid #1976d2;\n  outline-offset: -2px;\n}\n\n.nav-item.active {\n  background: #1976d2;\n  color: white;\n}\n\n.nav-item.active:focus {\n  outline: 2px solid #ffffff;\n  outline-offset: -2px;\n}\n\n.nav-icon {\n  margin-right: 12px;\n  font-size: 20px;\n}\n\n.nav-label {\n  flex: 1;\n}\n\n@media (max-width: 768px) {\n  .admin-sidebar {\n    width: 250px;\n  }\n  \n  .nav-label {\n    font-size: 14px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
